import React, { useEffect, useState } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import { LandingPageLayout } from '../../../lib/landing-page-layout'
import { theme } from '../../../lib/theme'
import { SignUpForm } from '../../components/sign-up-form'
import { LandingMessage, LandingMessageType } from '../../../lib/landing-message'
import Text from '../../../ui/Text'
import useText from '../../../common/hooks/useText'

const Title = styled.div`
    font-size: 24px;
    margin-bottom: 20px;
`

export type SignUpPageProps = {
    className?: ClassName
    style?: React.CSSProperties
}

export function SignUpPage({ className, style }: SignUpPageProps): React.ReactElement {
    const navigate = useNavigate()
    const text = useText()
    const [status, setStatus] = useState<'signup' | 'success' | 'failed'>('signup')

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [status])

    return (
        <LandingPageLayout
            className={cn(className)}
            style={style}
            background={theme.whiteBackground}
            hideLanguageSelect
        >
            {status === 'signup' && <SignUpForm setStatus={setStatus} />}
            {status === 'failed' && (
                <LandingMessage
                    linkText={text('lblReturnToSignIn')}
                    onClick={() => navigate('/login', { replace: true })}
                    type={LandingMessageType.ERROR}
                >
                    <Title data-testid="errorTitle">
                        <Text code="lblSomethingWentWrong" />
                    </Title>
                    <div data-testid="erroMessage">
                        <Text code="lblSignUpError" />
                    </div>
                </LandingMessage>
            )}
            {status === 'success' && (
                <LandingMessage
                    linkText={text('lblReturnToSignIn')}
                    onClick={() => navigate('/login', { replace: true })}
                    type={LandingMessageType.SUCCESS}
                >
                    <Title data-testid="successTitle">
                        <Text code="lblSignUpSuccessTitle" />
                    </Title>
                    <div data-testid="successMessage">
                        <Text code="lblSignUpSuccess" />
                    </div>
                </LandingMessage>
            )}
        </LandingPageLayout>
    )
}
